import React, { Component } from 'react';
import Main from './Main';
import 'typeface-gudea';
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
import AuthService from './AuthService';
import axios from 'axios';

axios.interceptors.request.use(
  config => {
    const Auth = new AuthService();
    const userIsAuthenticated = Auth.userAuthenticated();
    if (!userIsAuthenticated) {
      return config;
    }

    // webCookieAuthorizer only ever reads the sessionId/sessionIdLegacy
    // cookies now - the Bearer-token path it used to support was removed
    // along with Cognito, so cookies are the only auth mechanism left.
    config.withCredentials = true;
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#227a90',
      contrastText: '#fff'
    },
    secondary: {
      main: '#455560',
      contrastText: '#FFF'
    },
    text: {
      primary: '#455560'
    },
    error: {
      main: '#E83030'
    }
  },
  status: {
    danger: 'orange',
    error: '#E83030'
  },
  typography: {
    fontFamily: 'Gudea',
    fontSize: '14'
  }
});

class App extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <div>
          <Main />
        </div>
      </MuiThemeProvider>
    );
  }

  scriptLoaded() {
    this.Auth.refreshUserCredentials();
  }

  componentDidMount() {
    const script = document.createElement('script');
    script.src = 'https://admin.formstack.com/js/session-poller-v2.js';
    script.async = false;
    script.onload = () => this.scriptLoaded();

    document.body.appendChild(script);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js